// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2Prpd","row":"ProcedureTreatmentSummary_row__3Zcw_"};